import React, { useState } from "react";
import Header from "../Navigation/Header";
import Footer from "../Navigation/Footer";
import Sidebar from "../Navigation/Sidebar";
const Layout = ({ children, onCallFullScreen }) => {
  const [showSidebar, setShowSidebar] = useState(true);

  const toggleSidebar = () => {
    const body = document.getElementsByTagName("body")[0];
    if (showSidebar) {
      body.classList.add("sidebar-icon-only"); // Add or remove class
      setShowSidebar(false);
    } else {
      body.classList.remove("sidebar-icon-only"); // Add or remove class
      setShowSidebar(true);
    }
  };
  return (
    <>
      <div
        className={`container-scroller ${
          showSidebar ? "" : "sidebar-icon-only"
        }`}
      >
        <Header
          onToggleSidebar={toggleSidebar}
          onCallFullScreen={onCallFullScreen}
        />
        <div className={`container-fluid page-body-wrapper `}>
          <Sidebar showSidebar={showSidebar} />
          <div className="main-panel">
            <div
              className={`content-wrapper ${
                showSidebar ? "" : "sidebar-collapse"
              }`}
            >
              {children}
            </div>
            <Footer/>
          </div>
        </div>
      </div>
    </>
  );
};

export default Layout;
